"use client"

import Fade from 'react-reveal/Fade';
import conseiller1 from "../../../public/conseiller2.svg"
import conseiller2 from "../../../public/conseiller3.png"
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import heelio from "../../../public/heelio-mini.svg"
function Accompagnement() {

    const router = useRouter()

    return(
        <div id="offre" className='max-w-[1400px] mx-auto pt-20'>
            <div className="overflow-hidden">
                <Fade bottom>
                    <h4 className="text-2xl font-bold tracking-tight text-center text-gray-900 sm:text-5xl">
                    Votre directeur financier heelio
                    </h4>
                </Fade>
            </div>
            <div className="overflow-hidden pb-5">
                <Fade bottom>
                    <h4 className="text-2xl font-bold tracking-tight text-center text-gray-900 sm:text-5xl">
                    vous accompagne (<span className="underline">vraiment</span>)
                    </h4>
                </Fade>
            </div>

            <div className="overflow-hidden">
                <Fade bottom>
                    <p className="mt-4 text-xl leading-8 text-gray-600 text-center">
                        Interventions récurrentes en tant que directeur financier à temps partiel
                    </p>
                </Fade>
            </div>

            <div className="grid grid-cols-2 xl:grid-cols-3 grid-rows-2 gap-5 text-[#042040] mx-2 my-20 md:mx-20">
                <div className='w-full py-5 px-10 shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 rounded-lg border border-4 hover:border-[#FED90F] border-[#042040] relative z-1 bg-[#CCDDEE] flex flex-col justify-center items-center col-span-2 group'>
                    <div className='absolute w-[90px] h-[42px] rounded-bl-full rounded-br-full -bottom-[51px] left-1/2 -translate-x-1/2 bg-white z-0' style={{zIndex:2}}></div>

                    <div className='absolute w-20 h-12 rounded-bl-full rounded-br-full -bottom-10 left-1/2 -translate-x-1/2 border border-4 ease-in duration-500 group-hover:border-[#FED90F] border-[#042040] bg-[#CCDDEE] z-2' style={{zIndex:2}}></div>
                    <div className='absolute w-20 h-2 bottom-0 left-1/2 -translate-x-1/2 bg-[#CCDDEE] z-2' style={{zIndex:2}}></div>

                    <div className='flex flex-col md:flex-row justify-center items-center gap-10'>
                        <div className='w-full md:w-3/4 text-center md:text-left'>
                            <h5 className='text-3xl font-bold mb-5 text-[#042040]'>Analysez mieux.</h5>
                            <p>Confiez vos chiffres à nos experts. Nous scrutons vos finances pour vous offrir une vision claire et fiable. Une expertise adaptée à votre activité.</p>
                            <p 
                                onClick={() => router.push("/accompagnement")}
                                className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                            ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                        </div>

                        <svg className='w-full md:w-1/3' width="120" height="120" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg"  xmlnsXlink="http://www.w3.org/1999/xlink" 
                            viewBox="0 0 32 32" xmlSpace="preserve">
                            <path className="st0" d="M29,7H3V5c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V7z"/>
                            <path className="st0" d="M26,22H6c-1.1,0-2-0.9-2-2V7h24v13C28,21.1,27.1,22,26,22z"/>
                            <polyline className="st0" points="9,30 16,22 16,29 "/>
                            <line className="st0" x1="23" y1="30" x2="16" y2="22"/>
                            <circle className="st0" cx="13" cy="14" r="4"/>
                            <polyline className="st0" points="13,10 13,14 17,14 "/>
                            <line className="st0" x1="20" y1="12" x2="23" y2="12"/>
                            <line className="st0" x1="20" y1="16" x2="23" y2="16"/>
                        </svg>
                        
                    </div>
                    
                    
                </div>

                <div className="col-start-1 py-5 px-10 row-start-2 shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 rounded-lg border border-4 hover:border-[#FED90F] border-[#042040] relative bg-white flex flex-col justify-center items-center col-span-2 group">
                    <div className='absolute xl:w-[40px] w-[90px] xl:h-[90px] h-[42px] rounded-tr-none xl:rounded-tr-full rounded-br-full rounded-bl-full xl:rounded-bl-none right-1/2 xl:-right-[49px] -bottom-[51px] xl:bottom-1/2 translate-x-1/2 xl:translate-x-0 translate-y-none xl:translate-y-1/2 bg-white z-0' style={{zIndex:2}}></div>

                    <div className='block xl:hidden absolute xl:w-12 w-20 xl:h-20 h-12 rounded-tr-none xl:rounded-tr-full rounded-br-full rounded-bl-full xl:rounded-bl-none right-1/2 xl:-right-10 -bottom-10 xl:bottom-1/2 translate-x-1/2 xl:translate-x-0 translate-y-none xl:translate-y-1/2 border border-4 ease-in duration-500 group-hover:border-[#FED90F] border-[#042040] bg-white z-2' style={{zIndex:2}}></div>

                    <div className='hidden xl:block absolute xl:w-12 w-20 xl:h-20 h-12 rounded-tr-none xl:rounded-tr-full rounded-br-full rounded-bl-full xl:rounded-bl-none right-1/2 xl:-right-10 -bottom-10 xl:bottom-1/2 translate-x-1/2 xl:translate-x-0 translate-y-none xl:translate-y-1/2 border border-4 ease-in duration-500 group-hover:border-[#FED90F] border-[#042040] bg-white z-2' style={{zIndex:2}}></div>

                    <div className='absolute xl:w-2 w-20 xl:h-20 h-2 right-1/2 xl:right-0 bottom-0 xl:bottom-1/2 translate-x-1/2 xl:translate-x-0 translate-y-none xl:translate-y-1/2 bg-white' style={{zIndex:2}}></div>


                    <div className='flex justify-center items-center gap-10 flex-col md:flex-row'>
                        <div  className='w-3/4 text-center md:text-left'>
                            <h5 className='text-3xl font-bold mb-5 text-[#042040]'>Prévoyez efficacement.</h5>
                            <p>Ne soyez jamais pris au dépourvu. Nos experts construisent et ajustent vos prévisions, en s&apos;alignant sur vos dernières tendances. De la fiabilisation des hypothèses opérationnelles et commerciales au financement à long terme, nous prenons en charge chaque aspect de votre planification financière.</p>
                            <p 
                                onClick={() => router.push("/accompagnement")}
                                className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                            ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                        </div>

                        <svg version="1.1" className='w-full md:w-1/3' width="120" height="120" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
                        viewBox="0 0 32 32" xmlSpace="preserve">
                            <line className="st0" x1="16" y1="9" x2="16" y2="10"/>
                            <line className="st0" x1="16" y1="16" x2="16" y2="17"/>
                            <path className="st0" d="M17,10h-1.5c-0.8,0-1.5,0.7-1.5,1.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5
                                H15"/>
                            <path className="st0" d="M24,12c0-4.7-4.1-8.5-8.9-7.9c-3.5,0.4-6.4,3.2-7,6.7c-0.4,2.6,0.5,5.1,2.1,6.8c1.2,1.2,1.8,2.8,1.8,4.5v0h8v0
                                c0-1.6,0.6-3.3,1.7-4.4C23.1,16.1,24,14.2,24,12z"/>
                            <line className="st0" x1="20" y1="25" x2="12" y2="25"/>
                            <path className="st0" d="M19,26c0,1.7-1.3,3-3,3s-3-1.3-3-3"/>
                            <line className="st0" x1="4" y1="13" x2="2" y2="13"/>
                            <line className="st0" x1="7.5" y1="21.5" x2="6.1" y2="22.9"/>
                            <line className="st0" x1="24.5" y1="21.5" x2="25.9" y2="22.9"/>
                            <line className="st0" x1="28" y1="13" x2="30" y2="13"/>
                            <line className="st0" x1="24.5" y1="4.5" x2="25.9" y2="3.1"/>
                            <line className="st0" x1="7.5" y1="4.5" x2="6.1" y2="3.1"/>
                        </svg>
                        
                    </div>


                </div>
                

                <div className="col-start-1 xl:col-start-3 row-start-3 xl:row-start-1 py-10 px-5 shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 rounded-lg border border-4 hover:border-[#FED90F] border-[#042040] relative bg-[#fff7cf] flex flex-col justify-center items-center row-span-1 xl:row-span-2 col-span-2 xl:col-span-1 group">
                    <div className='hidden xl:block absolute -top-6 left-5'>
                        <div className='flex -space-x-3'>
                            <Image src={conseiller1} alt="conseiller heelio" width={50}/>
                            <Image src={conseiller2} alt="conseiller heelio" width={50}/>
                        </div>
                        
                    </div>
                    <div className='hidden xl:block absolute w-[45px] h-[95px] rounded-tl-full rounded-bl-full -left-[50px] top-1/4 -translate-y-1/2 bg-white z-0' style={{zIndex:0}}></div>

                    <div className='hidden xl:block absolute w-12 h-20 rounded-tl-full rounded-bl-full -left-10 top-1/4 -translate-y-1/2 border border-4 ease-in duration-500 group-hover:border-[#FED90F] border-[#042040] bg-[#fff7cf] z-2' style={{zIndex:2}}></div>
                    <div className='hidden xl:block absolute w-2 h-20 left-0 top-1/4 -translate-y-1/2 bg-[#fff7cf] z-2' style={{zIndex:2}}></div>


                    <div className='flex flex-col md:flex-row xl:flex-col justify-center items-center gap-10'>
                        <div  className='w-3/4 text-center md:text-left'>
                            <h5 className='text-3xl font-bold mb-5 text-[#042040] flex justify-center md:justify-start items-center gap-3'>
                                <span>Soyez accompagnés.</span>
                                <div className='hidden md:flex xl:hidden -space-x-3'>
                                    <Image src={conseiller1} alt="conseiller heelio" width={40}/>
                                    <Image src={conseiller2} alt="conseiller heelio" width={40}/>
                                </div>
                            </h5>
                            <p>Plus qu&apos;un conseil, une collaboration. Que ce soit pour une interaction régulière ou un besoin ponctuel, nos experts financiers sont là pour vous.</p>
                            <p 
                                onClick={() => router.push("/accompagnement")}
                                className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                            ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                        </div>

                        <svg className='w-full md:w-1/3' width="120" height="120" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
                            viewBox="0 0 32 32" xmlSpace="preserve">
                            <path className="st0" d="M17,27H4c-1.1,0-2-0.9-2-2v-4.4"/>
                            <path className="st0" d="M14,24L14,24c-1.1,0-2-0.9-2-2v-3h4v3C16,23.1,15.1,24,14,24z"/>
                            <path className="st0" d="M18,8h-8V6c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2V8z"/>
                            <line className="st0" x1="5" y1="28" x2="5" y2="27"/>
                            <circle className="st0" cx="24" cy="24" r="7"/>
                            <line className="st0" x1="24" y1="21" x2="24" y2="27"/>
                            <line className="st0" x1="21" y1="24" x2="27" y2="24"/>
                            <path className="st0" d="M12,22H5c-2.2,0-4-1.8-4-4v-8c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2v7.7"/>
                        </svg>
                        
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Accompagnement;